var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myNewsDatailsBox"},[_c('div',{staticClass:"mndb_title"},[_vm._v(_vm._s(_vm.info.VTitle))]),_vm._v(" "),_c('div',{staticClass:"mndb_date"},[_vm._v(_vm._s(_vm.info.createdTime))]),_vm._v(" "),_c('div',{staticClass:"mndb_con"},[_vm._v(_vm._s(_vm.info.VContent))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5159f80b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personalcenter/components/my/datails.vue
// module id = null
// module chunks = 